import React from 'react';
import { MDBFooter, MDBContainer, MDBRow, MDBCol, MDBIcon } from 'mdb-react-ui-kit';
import classes from './Footer.module.css';

const Footer = () => {
  return (
    <MDBFooter className={classes.footer}>
      <section className="d-flex justify-content-center p-4 border-bottom">
        <div>
          <span className="me-4 text-reset">
            <MDBIcon fab icon="facebook-f" />
          </span>
          <span className="me-4 text-reset">
            <MDBIcon fab icon="twitter" />
          </span>
          <span className="me-4 text-reset">
            <MDBIcon fab icon="google" />
          </span>
          <span className="me-4 text-reset">
            <MDBIcon fab icon="instagram" />
          </span>
          <span className="me-4 text-reset">
            <MDBIcon fab icon="linkedin" />
          </span>
          <span className="me-4 text-reset">
            <MDBIcon fab icon="github" />
          </span>
        </div>
      </section>

      <section className="">
        <MDBContainer className="text-center text-md-start mt-5">
          <MDBRow className="mt-3">
            <MDBCol md="6" lg="4" xl="3" className="mx-auto mb-4">
              <h6 className={classes.icon}>Stash</h6>
              <p>
                Stash provides lots of online services, you can keep up with us on via our social
                media platforms links provided.
              </p>
            </MDBCol>

            <MDBCol md="6" lg="3" xl="3" className="mx-auto mb-md-0 mb-4">
              <h6 className="text-uppercase fw-bold mb-4">Contact</h6>
              <p>
                <MDBIcon icon="home" className="me-2" />
                Empire Buildings - Erbil, Kurdistan
              </p>
              <p>
                <MDBIcon icon="envelope" className="me-3" />
                info@stash.com
              </p>
              <p>
                <MDBIcon icon="phone" className="me-3" /> + 01 234 567 88
              </p>
            </MDBCol>
          </MDBRow>
        </MDBContainer>
      </section>

      <div className={classes.trademark}>© 2022 Stash</div>
    </MDBFooter>
  );
};

export default Footer;
